module.exports = __webpack_public_path__ + "img/pdd.e06a9328.png";